/*
 * FileName : newsNotice.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2022-01-04 18:17:51
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

// eslint-disable-next-line no-use-before-define
import React from 'react';
import ReactDOM from 'react-dom';
import Icon from 'src/assets/imgs/common/formlight.png';
import { CloseOutlined } from '@ant-design/icons';
import { LangMessage } from 'src/store/common/language';

type Rows = {
    deviceNo: string;
    deviceAddr: string;
    etime: string;
}

type Props = {
    title: string;
    row: Rows;
    type: 'onOff' | 'alarm';
    Mes: LangMessage;
}

const newsNotice = (props:Props) => {
    const { row, title, type, Mes } = props;
    const id = 'dviceNotice';
    const notcie = document.getElementById(id) as HTMLElement;

    if (!notcie && !window.config?.isHideNotice) {
        const dom = document.createElement('div');
        const closeEvent = (selector:string) => {
            const news = document.getElementById(selector) as HTMLElement;

            if (news) {
                document.body.removeChild(news);
            }
        };

        dom.setAttribute('id', id);
        dom.setAttribute('class', 'newModal');
        document.body.appendChild(dom);
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.render((<div className='newNotice'>
            <h6>
                <span className={`text ${type === 'alarm' ? 'alarmText' : ''}`} title={title}>{title}</span>
                <CloseOutlined onClick={() => closeEvent(id)} />
            </h6>
            <div className='intro'>
                <div className='info'>
                    <p>
                        <label>{ Mes['titleTableOccurtimeoccurtime'] }:</label>
                        <span title={row.etime}>{ row.etime }</span>
                    </p>
                    <p>
                        <label>{ Mes['titleTableDevicenodeviceno'] }:</label>
                        <span title={row.deviceNo}>{ row.deviceNo }</span>
                    </p>
                    {
                        row.deviceAddr && (
                            <p>
                                <label>{ Mes['titleTableDeviceaddressdeviceaddress'] }:</label>
                                <span title={row.deviceAddr}>{ row.deviceAddr }</span>
                            </p>
                        )
                    }
                </div>
                <img src={Icon} alt='title' />
            </div>
        </div>), dom);
        setTimeout(() => {
            const news = document.getElementById(id) as HTMLElement;

            if (news) {
                document.body.removeChild(news);
            }
        }, window?.config?.noticeTime || 3000);
    }
};

export default newsNotice;
